import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { MessageService } from '../../services/message.service';
import { NaviService } from '../../services/navi.service';

import { BasicError } from '../../models/error/error';
import { User } from '../../models/user';
import { Thread } from '../../models/thread';
declare var $: any;

@Component({
  selector: 'app-hcp-messaging-new',
  templateUrl: './hcp-messaging-new.component.html',
  styleUrls: ['./hcp-messaging-new.component.css']
})
export class HcpMessagingNewComponent implements OnInit {
  public participants: Array<User> = [];
  public allusers: Array<User> = [];
  public isEmptyUsers = false;
  public lastUpdateCountAllUsers = 0;
  public timeoutAllUsers = null;
  public subject: String = null;
  public message: String = null;
  public buttonValue: String = 'Senden';
  public buttonClass: String = '';
  public buttonRedirectClass: String = '';
  public buttonRedirectText: String = 'Weiterleitung abbrechen';
  public buttonRedirectShow = false;
  public isErrorSubject = false;
  public isErrorMessage = false;
  public onSend = false;
  public thread = null;
  public redirectTimer = null;

  constructor(private userService: UserService, private messageService: MessageService, private naviService: NaviService) { }

  ngOnInit() {

  }

  /*
   * This function gets all Users.
   */
  public getAllUsers() {
    if (this.allusers.length !== 0) {
      return;
    }

    $('#datatableAllUsers').dataTable().fnDestroy();
    this.lastUpdateCountAllUsers = 0;
    this.allusers = [];
    this.userService.getAllUsers().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading all users');
      } else if (data instanceof Array) {
        const tmp = this.allusers.concat(data);
        this.allusers = [];

        $('#datatableAllUsers').dataTable().fnDestroy();

        this.allusers = tmp;

        if (this.allusers.length !== 0) {
          this.isEmptyUsers = false;
        }
      }
    });

    if (this.allusers.length === 0) {
      this.isEmptyUsers = true;
    }
  }


  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllUsers() {
    if (this.lastUpdateCountAllUsers !== this.allusers.length) {
      this.lastUpdateCountAllUsers = this.allusers.length;

      if (this.timeoutAllUsers !== null) {
        clearTimeout(this.timeoutAllUsers);
      }

      this.timeoutAllUsers = setTimeout(function () {
        $('#datatableAllUsers').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }

  /**
   * adding a user to the participants
   * @param user User to add
   */
  public addParticipant(user: User) {
    const index = this.participants.indexOf(user, 0);
    // $('#ModalAddParticipant').modal('hide');
    if (index === -1) {
      this.participants.push(user);
    }
  }

  /**
   * Removing participant from list
   * @param user User to be removed
   */
  public removeParticipant(user: User) {
    const index = this.participants.indexOf(user, 0);
    if (index > -1) {
      this.participants.splice(index, 1);
    }
  }

  public sendMessage() {
    let isOk = true;
    this.isErrorSubject = false;
    this.isErrorMessage = false;

    if (this.subject === null || this.subject.length === 0) {
      this.isErrorSubject = true;
      isOk = false;
    }

    if (this.message === null || this.message.length === 0) {
      this.isErrorMessage = true;
      isOk = false;
    }

    if (!isOk) {
      return;
    }

    if (this.onSend) {
      return;
    }

    this.onSend = true;

    this.buttonClass = 'sendingButton';
    this.buttonValue = 'Wird gesendet...';

    // Create thread
    const thread = new Thread(null, this.subject);
    this.messageService.createNewThread(thread).subscribe(res => {
      if (res instanceof BasicError) {
        console.log('Failed to create Thread.');
        console.log(res);
        this.buttonClass = 'btn-danger';
        this.buttonValue = 'Senden fehlgeschlagen';
        this.onSend = false;
        return;
      }

      // Thread was created
      if (res instanceof Thread && res.getId() !== null) {
        this.thread = res;
        this.messageService.sendMessage(thread, this.message).subscribe(msg => {
          if (msg instanceof BasicError) {
            console.log('Failed to send Message');
            console.log(msg);
            this.buttonClass = 'btn-warning';
            this.buttonValue = 'Nachricht konnte nicht gesendet werden';
            this.onSend = false;
            return;
          }

          if (this.participants.length > 0) {
            this.messageService.addParticipants(thread, this.participants).subscribe(usr => {
              if (usr instanceof BasicError) {
                console.log('Failed to add participants');
                console.log(usr);
                this.buttonClass = 'btn-warning';
                this.buttonValue = 'Teilnehmer konnten nicht hinzugefügt werden';
                return;
              }

              this.buttonClass = 'sendedButton';
              this.buttonValue = 'Versendet';
              this.buttonRedirectShow = true;
              const self = this;
              setTimeout(function () {
                self.buttonRedirectClass = 'redirectAbort';
              }, 100);
              this.redirectTimer = setTimeout(function () { self.redirect(self.thread, self); }, 2000);
            });
          } else {
            this.buttonClass = 'sendedButton';
            this.buttonValue = 'Versendet';
            this.buttonRedirectShow = true;
            const self = this;
            setTimeout(function () {
              self.buttonRedirectClass = 'redirectAbort';
            }, 100);
            this.redirectTimer = setTimeout(function () { self.redirect(self.thread, self); }, 2000);
          }
        });
      } else {
        // Thread was created but failed to get Id
        console.log('Failed to get Id of thread');
        this.buttonClass = 'btn-warning';
        this.buttonValue = 'Thread erstellt, Nachricht fehlgeschlagen';
        this.onSend = false;
      }
    });
  }

  /**
   * This function redirects to the corresponding message that was created
   */
  public redirect(thread, self) {
    let url = '/hcp/messages/';
    url += thread.getId();
    self.naviService.navigateToUrl(url, 'hcpmessages');
  }

  /**
   * This function aborts the redirection to the message
   */
  public abortRedirect() {
    if (this.redirectTimer !== null) {
      clearTimeout(this.redirectTimer);
      this.buttonRedirectClass = 'redirect';
      this.buttonRedirectText = 'Zur Nachricht';
    }
  }

  /**
   * Decide if a redirection is necessary or the redirection will canceled
   */
  public redirectButtonTrigger() {
    if (this.redirectTimer !== null) {
      this.abortRedirect();
    } else {
      this.redirect(this.thread, this);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-messaging-new/hcp-messaging-new.component.ts